import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
    Card,
    CardBody
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

export default function UnifiedInbox({
    saveIntegration,
    channelDetails
}) {
    const [isReceivingEmail, setIsReceivingEmail] = useState(channelDetails !== null ? channelDetails.isReceivingEmail : false);
    const [isReplies, setIsReplies] = useState(channelDetails !== null ? channelDetails.isRepliesEmail : false);
    const handleReceiving = (e) => {
        var details = { ...channelDetails };
        details.isReceivingEmail = e;
        setIsReceivingEmail(e);
        saveIntegration({ channelDetails: details });
    };
    const handleReplies = (e) => {
        var details = { ...channelDetails };
        details.isRepliesEmail = e;
        setIsReplies(e);
        saveIntegration({ channelDetails: details });
    };
    return (<Fragment>
        <Card className="mb-4">
            <CardBody>
                <div className="text-center mb-2">
                    <h6>Enable Unified Inbox</h6>
                    <span>Forward email from your normal support email address (such as help@myapp.com) to Unified Inbox so you can view and reply to emails from your inbox.</span>
                </div>
                <Separator className="mb-3" />
                <div className="row mt-1 ml-2 mb-1">
                    <div className="d-flex w-100">
                        <h5 style={{ marginTop: '0.15rem' }}>Enable Receiving Emails</h5>
                        <Switch
                            className="agentswitch custom-switch-primary custom-switch-small ml-2"
                            checked={isReceivingEmail}
                            name='enabled'
                            onChange={(e) => handleReceiving(e)}
                        />
                    </div>
                    <p className="mb-2 mt-2">Enable Unified Inbox to receive and show forwarded emails</p>
                </div>
                <Separator className="mb-3" />
                <div className="row mt-1 ml-2 mb-1">
                    <div className="d-flex w-100">
                        <h5 style={{ marginTop: '0.15rem' }}>Enable Replies</h5>
                        <Switch
                            className="agentswitch custom-switch-primary custom-switch-small ml-2"
                            checked={isReplies}
                            name='enabled'
                            onChange={(e) => handleReplies(e)}
                        />
                    </div>
                    <p className="mb-2 mt-2">Enable the ability to reply to emails from Unified Inbox</p>
                </div>
            </CardBody>
        </Card>
    </Fragment>)
}  